<template>
  <div class="w-100">
    <b-row>
      <b-col>
        <div class="d-flex justify-content-end mb-2">
          <b-button
            size="sm"
            variant="primary"
            :disabled="selectedRowItemId == 0"
            @click="$refs['pick-ticket-reports-modal'].showModal()">
            Print
          </b-button>
        </div>
      </b-col>
    </b-row>

    <grid-component
      isResizable
      isReorderable
      :gridId="gridId"
      :fields="fields"
      :itemData="itemData"
      :handleRowClick="onRowClick"
    />

    <!-- <report-viewer :modalId="modalId" :reportName="'PickTicket'" :parameter="{ PickTicketLine: selectedRowItemId }"  /> -->
    <fast-report-viewer ref="pick-ticket-reports-modal" :modalId="modalId" :moduleName="'PickTicket'" :parameter="selectedRowItemId" />
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

import { GRID_ID } from '@/shared/constants';
import GridComponent from '@/shared/components/GridComponent';
import ReportViewer from '@/shared/components/ReportViewer';
import FastReportViewer from '@/shared/components/FastReportViewer';
import fields from './fields';

export default {
  components: {
    GridComponent,
    ReportViewer,
    FastReportViewer
  },
  data() {
    return {
      fields,
      gridId: GRID_ID.PICK_TICKET_LINES,
      selectedRowItemId: 0,
      modalId: 'pick-ticket-reports-modal'
    }
  },
  props: {
    invoiceLineId: {
      type: [Number, String],
      default: 0
    },
    serviceOrderLineId: {
      type: [Number, String],
      default: 0
    },
    isWOTab: {
      type: Boolean,
      default: false
    },
    isVRMATab: {
      type: Boolean,
      default: false
    },
    vendorRmaLineId: {
      type: [Number, String],
      default: 0
    }
  },
  computed: {
    ...mapGetters('pickTicket', ['pickTicketLinesByInvoiceLine', 'pickTicketLinesByServiceOrderLine', 'pickTicketLinesByVendorRMALine']),
    itemData() {
      let item = [];
      if(this.isWOTab){
        item = this.pickTicketLinesByServiceOrderLine
      }else if(this.isVRMATab){
        item = this.pickTicketLinesByVendorRMALine
      }else{
        item = this.pickTicketLinesByInvoiceLine
      }

      if(item.length){
        return item.map((pickTicket) => ({
          ...pickTicket,
          selected: pickTicket.pickTicketId == this.selectedRowItemId
        }));
      }else{
        return item;
      }
    }
  },
  methods: {
    ...mapActions('pickTicket', ['getPickTicketsByInvoiceLine', 'getPickTicketsByServiceOrderLine', 'getPickTicketsByVendorRmaLine']),
    onRowClick(row) {
      this.selectedRowItemId = row.dataItem.pickTicketId;
    },
    onPrintPickTicket() {
      this.$bvModal.show('view-reports-modal');
    }

  },
  watch: {
    async invoiceLineId() {
      await this.getPickTicketsByInvoiceLine([this.invoiceLineId]);
    },
    async serviceOrderLineId() {
      // debugger;
      await this.getPickTicketsByServiceOrderLine([this.serviceOrderLineId]);
    },
    async vendorRmaLineId() {
      await this.getPickTicketsByVendorRmaLine([this.vendorRmaLineId]);
    }
  }
}

</script>